module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/notes-cf3f964731bb91d3896c1aab8fd25153.svg";